"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const getContent_1 = require("../../helpers/getContent");
const getState_1 = require("../../helpers/getState");
const JSON_parseSafe_1 = require("../../helpers/JSON_parseSafe");
const setStartedOn_1 = tslib_1.__importDefault(require("../helpers/setStartedOn"));
const updateProgressMeasureAndCompletionStatusForScormCard_1 = require("./updateProgressMeasureAndCompletionStatusForScormCard");
const updateRawScoreAndSuccessStatusForScormCard_1 = require("./updateRawScoreAndSuccessStatusForScormCard");
const updateReAttemptCountForScormCard_1 = require("./updateReAttemptCountForScormCard");
const updateTimeSpentForScormCard_1 = require("./updateTimeSpentForScormCard");
function applyUpdateScormCommannd(command, 
// @ts-ignore: maintain function signature
user, content, states) {
    const { contentId, userId, timeStamp, mastery_score, reAttemptCount = 0, score_raw, scormData } = command;
    const events = [];
    const currentContent = getContent_1.getContentByContentId(content, contentId);
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        const currentTimeSpent = state.timeSpent;
        if (!state.scorm) {
            state.scorm = {};
        }
        state.scorm.mastery_score = mastery_score;
        state.scorm.score_raw = score_raw;
        if (scormData) {
            const newScormDataObject = JSON_parseSafe_1.JSON_parseSafe(scormData);
            const currentScormDataObject = JSON_parseSafe_1.JSON_parseSafe(state.scorm.scormData);
            const finalScormDataObject = Object.assign({}, currentScormDataObject, newScormDataObject);
            updateProgressMeasureAndCompletionStatusForScormCard_1.updateProgressMeasureAndCompletionStatusForScormCard(currentContent, finalScormDataObject, state);
            updateReAttemptCountForScormCard_1.updateReAttemptCountForScormCard(currentContent, reAttemptCount, state);
            updateRawScoreAndSuccessStatusForScormCard_1.updateRawScoreAndSuccessStatusForScormCard(currentContent, finalScormDataObject, state);
            updateTimeSpentForScormCard_1.updateTimeSpentForScormCard(currentContent, finalScormDataObject, state);
            const finalScormData = JSON.stringify(finalScormDataObject);
            state.scorm.scormData = finalScormData;
        }
        if (currentTimeSpent !== state.timeSpent) {
            state.lastAccessedOn = state.updatedAt = state.lastUpdatedTimeSpent = timeStamp;
        }
        setStartedOn_1.default(state, timeStamp);
    });
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyUpdateScormCommannd = applyUpdateScormCommannd;
//# sourceMappingURL=index.js.map